import { FieldType, IFieldFieldsFragment } from './apollo/graphqlSchema';

export const isNestedField = (field: Pick<IFieldFieldsFragment, 'type'>) => {
  return (
    field.type === FieldType.Json ||
    field.type === FieldType.ArrayObject ||
    field.type === FieldType.Struct ||
    field.type === FieldType.Map
  );
};
